import React, { useEffect, useState } from "react";
import { forwardToNewDesign } from "../../utils/forwardToNewDesign";
import { useNavigate } from "react-router-dom";
import { postRequest } from "../../services/api/apiService";
import { getAuthToken } from "../../utils/auth";
import { afterPlatformConnect } from "../../utils/afterPlatformConnect";

const TikTokAdsCallback = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (forwardToNewDesign()) return; // tunnel lancé depuis un autre client OneBotAds
    // Extract the authorization code and CSRF state from the query string
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");
    const state = queryParams.get("state");

    const token = getAuthToken(); // Retrieve the user's auth token

    if (!code) {
      console.error("Authorization code not found");
      setError("Authorization code missing.");
      navigate("/error", {
        state: {
          errorCode: "400",
          errorMessage: "Authorization code missing.",
        },
      });
      return;
    }

    try {
      // Send the authorization code and CSRF state to the backend
      postRequest(
        "/api/ads-auth/tiktok/callback",
        { code, state },
        { Authorization: `Bearer ${token}` }
      )
        .then((response) => {
          if (response.success) {
            // Redirect to dashboard upon successful authentication
            navigate(afterPlatformConnect());
          } else {
            setError("Failed to save TikTok Ads account details.");
            navigate("/error", {
              state: {
                errorCode: "500",
                errorMessage: "Failed to save TikTok Ads account details.",
              },
            });
          }
        })
        .catch((error) => {
          console.error("Error during TikTok Ads authentication:", error);
          const errorMessage =
            error?.response?.data?.message ||
            "Error during the TikTok Ads authentication process.";
          setError(errorMessage);
          navigate("/error", {
            state: {
              errorCode: String(error?.response?.status || 500),
              errorMessage,
            },
          });
        });
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  }, [navigate]);

  return <div>{error && <p>{error}</p>}</div>;
};

export default TikTokAdsCallback;
